module.exports = __webpack_public_path__ + "img/home_logo.b2d74c87.png";